import { useMemo } from 'react'

import { AccountsShell } from '@/modules/accounts/components/AccountsShell/AccountsShell'

import { NoAccounts } from '@/components/@Shared/NoAccounts/NoAccounts'
import { Loader } from '@/components/Loader/Loader'

import { useBankingServiceBankingControllerGetAccounts } from '@/__generated__/queries'
import type { AccountData } from '@/__generated__/requests'

export function Component() {
  const { data, isFetching, isLoading } =
    useBankingServiceBankingControllerGetAccounts()

  const userAccounts = useMemo<AccountData[]>(
    () => data?.accounts ?? [],
    [data],
  )

  if (isLoading || isFetching) {
    return <Loader isAuthenticatedLayout />
  }

  if (userAccounts.length) {
    return <AccountsShell accounts={userAccounts} />
  }

  return <NoAccounts />
}

Component.displayName = 'Accounts'
